module.exports = __webpack_public_path__ + "img/unity-game-service.ade3789f.jpg";